import { useSeoMeta } from '@unhead/react';
import { Dumbbell } from 'lucide-react';
import { CraftProfileForm } from '@/components/CraftProfileForm';
import {
  SKATE_TRAINER_KIND, TRAINER_FOCUS_LABELS, TRAINER_INJURY_LABELS, TRAINER_CREDENTIAL_LABELS,
} from '@/lib/types';

export default function BecomeTrainerPage() {
  useSeoMeta({
    title: 'Become a Trainer / Physio - SkateSpots',
    description: 'Help skaters get strong and stay healthy — strength, mobility, injury prevention and recovery.',
  });

  return (
    <CraftProfileForm
      config={{
        kind: SKATE_TRAINER_KIND,
        selfTag: 'skatetrainer',
        identifier: 'trainer-profile',
        heading: 'Trainer / Physio',
        tagline: 'Strength, mobility, injury prevention & recovery for skaters',
        noun: 'trainer',
        accentText: 'text-emerald-400',
        accentBg: 'bg-emerald-600',
        accentChip: 'bg-emerald-600 text-white border-emerald-600',
        accentChipHover: 'hover:border-emerald-500/60 hover:text-emerald-400',
        icon: Dumbbell,
        rateLabel: 'Rate / Session',
        portfolioLabel: 'Profile / booking link',
        skillSections: [
          { title: 'Focus', entries: Object.entries(TRAINER_FOCUS_LABELS), required: true },
          { title: 'Injuries You Work With', entries: Object.entries(TRAINER_INJURY_LABELS) },
          { title: 'Credentials & Setting', entries: Object.entries(TRAINER_CREDENTIAL_LABELS) },
        ],
        extraFields: [
          { tag: 'credentials', label: 'Certifications', placeholder: 'e.g. BSc Physiotherapy, CSCS…', helper: 'List real qualifications — skaters trust verifiable credentials.' },
          { tag: 'remote', label: 'Remote / Online', type: 'toggle', helper: 'Do you offer online coaching or consultations?' },
        ],
      }}
    />
  );
}
